import {
    Component,
    Inject,
    LOCALE_ID, NgModule,
    OnDestroy,
    OnInit,
    ViewChild,
} from "@angular/core";
import {AuthService} from "../../../services/auth.service";
import {Router} from "@angular/router";
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeInUpBigOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation,
} from "angular-animations";
import {UserInfoModel} from "../../../services/models/user-info.model";
import {UserService} from "../../../services/user.service";
import {Subscription} from "rxjs";
import {EventsService} from "../../../services/events.service";
import {ProgressModel} from "../../../services/models/progress.model";
import {ProgressService} from "../../../services/progress.service";
import {environment} from "../../../../environments/environment";
import {AnalyticsService} from "../../../services/analytics.service";
import {AlertController, NavController, Platform} from '@ionic/angular';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {CalendarComponent} from "ionic2-calendar";
import {TranslateService} from "@ngx-translate/core";
import {CoachAvailabilityModel, UpdateCoachAvailabilityModel} from "../models/availability.model";
import {CoachService} from "../service/coach.service";
import {NavService} from '../../../services/nav.service';
import * as moment from 'moment-timezone';
import {ToastService} from '../../../services/toast.service';
import {CalendarMode} from 'ionic2-calendar/calendar';

@Component({
    selector: "app-coach-availability-page",
    templateUrl: "coach-availability.page.html",
    styleUrls: ["coach-availability.page.scss"],
    animations: [
        fadeInOnEnterAnimation({anchor: "enter", duration: 500}),
        fadeOutOnLeaveAnimation({anchor: "leave", duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: "leaveList", duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: "enterList", duration: 300}),
        fadeInUpBigOnEnterAnimation({anchor: "enterUp", duration: 300}),
    ],
})
export class CoachAvailabilityPage implements OnInit, OnDestroy {
    subscriptions: Subscription[] = [];

    environment = null;
    menuVisible = true;
    viewTitle: string;
    eventSource = [];

    userInfo: UserInfoModel = null;
    userInfoPromise: Promise<UserInfoModel> = null;
    userInfoValid = false;

    progress: ProgressModel = null;
    progressPromise: Promise<ProgressModel> = null;
    progressValid = false;

    modalIsVisible = false;
    profileForm: FormGroup = null;
    availability: CoachAvailabilityModel[] = null;
    availabilityPromise: Promise<CoachAvailabilityModel[]> = null;
    pickedTime: CoachAvailabilityModel = null;
    confirmedTime: CoachAvailabilityModel = null;
    selectedDate = null;
    availabilityValid = false;

    currentDate = new Date();
    currentMonth = new Date().getMonth() + 1;
    currentYear = new Date().getFullYear();

    currentRange = null

    currentDateEventSelected = 0;
    currentDateEvent = [];
    currentDateEventChanged = [];
    chosenIonTime: string;
    eventChangesSaved = true;

    modalCount = 0;
    modalIsVisible2 = false;

    isCalendar = false;
    public animationState = false;
    calendar = {
        mode: "month" as CalendarMode,
        currentDate: new Date(),
    };

    lockSwipeToPrev = true;
    lockSwipes = true;
    platform = 'website';

    @ViewChild(CalendarComponent) myCal: CalendarComponent;

    constructor(
        private event: EventsService,
        public authService: AuthService,
        public userService: UserService,
        private analytics: AnalyticsService,
        private progressService: ProgressService,
        private coachService: CoachService,
        private navCtrl: NavController,
        private router: Router,
        private translate: TranslateService,
        private alertCtrl: AlertController,
        private nav: NavService,
        private toast: ToastService,
        private platformService: Platform,
        @Inject(LOCALE_ID) private locale: string
    ) {
        this.environment = environment;
        this.platform = this.authService.appMobile ? 'mobile' : 'website';
        this.subscriptions.push(
            this.event.subscribe("login", () => {
                this.userInfoValid = false;
                this.progressValid = false;
            })
        );
        this.subscriptions.push(
            this.event.subscribe("logout", () => (this.userInfoValid = false))
        );
        this.subscriptions.push(
            this.event.subscribe(
                "account.saveMyProfileForm",
                () => (this.userInfoValid = false)
            )
        );
        this.subscriptions.push(
            this.event.subscribe(
                "tasks:updateTaskStatus",
                () => (this.progressValid = false)
            )
        );
        this.subscriptions.push(
            this.event.subscribe("progress:getMyNotifications", (progress) => {
                this.progress = progress;
                this.progressValid = true;
            })
        );
    }

    ngOnInit(): void {
    }

    onChange() {
        this.event.publish('form:changed', 'availability');
        this.eventChangesSaved = false;
    }

    initForm() {
        this.profileForm = new FormGroup({
            timePicker: new FormControl("", Validators.required),
        });
    }

    ionViewWillEnter() {
        // this.availabilityPromise = this.coachService.getMyCoachAvailabilityList(
        //     this.currentRange.startTime.toISOString(),
        //     this.currentRange.endTime.toISOString()
        // );
    }

    ionViewDidEnter() {
        this.analytics.trackView("Coach Calendar");
        // if (this.availability === null || !this.availabilityValid) {
        //     this.availabilityPromise.then((data) => {
        //         this.availability = data;
        //         this.availabilityValid = true;
        //         this.getEvents();
        //         this.initForm();
        //     });
        // }
        this.initForm();
        setTimeout(() => {
            this.isCalendar = true;
        }, 0)
    }

    getEvents() {
        const events = [];
        const now = (new Date()).getTime();
        this.availability.forEach((item) => {
            const startTime = new Date(new Date(item.start_at).setSeconds(0, 0));
            const booked = (item.status === 'pending' || item.status === 'confirmed') && startTime.getTime() > now;
            const disabled = item.status !== 'available' || now > startTime.getTime();
            events.push({
                title: "",
                startTime: startTime,
                endTime: new Date(new Date(item.end_at).setSeconds(0, 0)),
                disabled: disabled,
                booked: booked,
                hidden: disabled && !booked,
                selected: true
            });
        });
        this.eventSource = events;
    }

    updateAvailabilityList() {
        if (this.profileForm) {
            this.availabilityValid = false;
            this.availabilityPromise = this.coachService.getMyCoachAvailabilityList(
                this.currentRange.startTime.toISOString(),
                this.currentRange.endTime.toISOString()
            );
            this.availabilityPromise.then((data) => {
                this.availability = data;
                this.availabilityValid = true;
                this.modalCount = 0;
                this.getEvents();
            });
        }
    }

    goBack() {
        this.navCtrl.back();
    }

    next() {
        this.lockSwipes = false;
        setTimeout(() => {
            this.myCal.slideNext();
        });
    }

    back() {
        if (!this.lockSwipeToPrev) {
            this.lockSwipes = false;
            setTimeout(() => {
                this.myCal.slidePrev();
            });
        }
    }

    onViewTitleChanged(title) {
      this.viewTitle = moment(this.currentDate).format('MMMM YYYY');

      this.currentMonth = this.currentDate.getMonth() + 1;
      this.currentYear = this.currentDate.getFullYear();

      this.lockSwipes = true;
      this.lockSwipeToPrev = (this.currentMonth <= new Date().getMonth() + 1 && this.currentYear <= new Date().getFullYear());
    }

    onRangeChanged(range) {
        this.modalCount = 0;
        this.currentRange = range;
        this.updateAvailabilityList()
    }

    onCurrentDateChanged(event) {
      this.currentDate = event;
    }


  onTimeSelected = (ev: { selectedTime: Date; events: any[] }) => {
        this.selectedDate = ev.selectedTime.toISOString().split("T")[0];
        this.currentDate = ev.selectedTime;
        this.currentDateEvent = this.createCurrentDateEventList(ev.events, this.selectedDate);
        this.currentDateEventSelected = this.currentDateEvent.reduce((sum, item) => sum + (!item.disabled && item.selected ? 1 : 0), 0)
        if (
            this.modalCount &&
            this.currentDateEvent.length &&
            window.innerWidth <= 719
        ) {
            this.modalIsVisible = true;
        }
        ++this.modalCount;
    };

    closeModal() {
        if (!this.eventChangesSaved) {
            this.alertCtrl.create({
                header: this.translate.instant('__ALERT_UNSAVED_TITLE__'),
                message: this.translate.instant('__ALERT_UNSAVED_MESSAGE__'),
                buttons: [{
                    text: this.translate.instant('__ALERT_UNSAVED_BUTTON_LEAVE__'),
                    cssClass: 'alert-controller-warning',
                    handler: () => {
                        this.eventChangesSaved = true;
                        this.modalIsVisible = false;
                        this.pickedTime = null;
                    }
                }, this.translate.instant('__ALERT_UNSAVED_BUTTON_STAY__')]
            }).then(a => a.present());
        } else {
            this.modalIsVisible = false;
            this.pickedTime = null;
        }
    }

    chosenTime(event) {
        if (!event.disabled) {
            this.eventChangesSaved = false;
            event.selected = !event.selected;
            this.currentDateEventSelected = this.currentDateEvent.reduce((sum, item) => sum + (!item.disabled && item.selected ? 1 : 0), 0)
            this.onChange();
        }
    }

    createCurrentDateEventList(dbEvents, selectedDate): any {
        let events = [];
        dbEvents.forEach((dbEvent) => {
            events.push({
                title: `${this.addZero(dbEvent.startTime.getHours())}:${this.addZero(dbEvent.startTime.getMinutes())} - ${this.addZero(dbEvent.endTime.getHours())}:${this.addZero(dbEvent.endTime.getMinutes())}`,
                startTime: dbEvent.startTime,
                endTime: dbEvent.endTime,
                disabled: dbEvent.disabled,
                booked: dbEvent.booked,
                hidden: dbEvent.disabled && !dbEvent.booked,
                selected: true
            });
        })
        const now = (new Date()).getTime();
        // let startTime = new Date(moment.tz(`${selectedDate}T07:00:00`, 'Europe/London').format());
        let startTime = new Date(`${selectedDate}T00:00:00`);
        let endTime = new Date(this.addMinToDate(startTime, 30));
        // let lastTime = new Date(moment.tz(`${selectedDate}T19:00:00`, 'Europe/London').format());
        let lastTime = new Date(`${selectedDate}T24:00:00`);
        let startTimeFixed = null;
        let endTimeFixed = null;
        const today = +selectedDate.slice(-2);
        while (startTime < lastTime) {
            let skip = false;
            startTimeFixed = new Date(startTime.toISOString());
            endTimeFixed = new Date(endTime.toISOString());
            if (startTime.getDate() > today) {
                startTimeFixed.setDate(startTime.getDate() - 1);
                endTimeFixed.setDate(endTime.getDate() - 1);
            } else if (startTime.getDate() < today) {
                startTimeFixed.setDate(startTime.getDate() + 1);
                endTimeFixed.setDate(endTime.getDate() + 1);
            }
            dbEvents.forEach((dbEvent) => {
                let startTimeDb = dbEvent.startTime;
                let endTimeDb = dbEvent.endTime;
                if (startTimeFixed < endTimeDb && startTimeDb < endTimeFixed) {
                    skip = true;
                }
            })
            if (!skip) {
                events.push({
                    title: `${this.addZero(startTimeFixed.getHours())}:${this.addZero(startTimeFixed.getMinutes())} - ${this.addZero(endTimeFixed.getHours())}:${this.addZero(endTimeFixed.getMinutes())}`,
                    startTime: startTimeFixed,
                    endTime: endTimeFixed,
                    disabled: now > startTimeFixed.getTime(),
                    booked: false,
                    hidden: now > startTimeFixed.getTime(),
                    selected: false
                })
            }
            startTime = this.addMinToDate(startTime, 30);
            endTime = this.addMinToDate(endTime, 30);
        }
        events = this.timeArraySort(events);
        return events;
    }

    addNewTime() {
        const now = (new Date()).getTime();
        let startTime = new Date(new Date(this.selectedDate + 'T' + this.chosenIonTime.split('T')[1]).setSeconds(0, 0))
        let endTime = this.addMinToDate(startTime, 30);
        let skip = false;
        let deleteItem = [];

        this.currentDateEvent.forEach((dbEvent) => {
            let startTimeDb = dbEvent.startTime;
            let endTimeDb = dbEvent.endTime;

            if (startTime < endTimeDb && startTimeDb < endTime && dbEvent.disabled === true) {
                skip = true;
            } else if (startTime < endTimeDb && startTimeDb < endTime && dbEvent.disabled === false) {
                deleteItem.push(dbEvent);
            }
        })

        if (!skip) {
            this.eventChangesSaved = false;
            deleteItem.forEach((item) => {
                this.currentDateEvent.splice(this.currentDateEvent.indexOf(item), 1);
            })
            this.currentDateEvent.push({
                title: `${this.addZero(startTime.getHours())}:${this.addZero(startTime.getMinutes())} - ${this.addZero(endTime.getHours())}:${this.addZero(endTime.getMinutes())}`,
                startTime: startTime,
                endTime: endTime,
                disabled: now > startTime.getTime(),
                booked: false,
                hidden: now > startTime.getTime(),
                selected: true
            })
            this.currentDateEvent = this.timeArraySort(this.currentDateEvent);
            this.currentDateEventSelected = this.currentDateEvent.reduce((sum, item) => sum + (!item.disabled && item.selected ? 1 : 0), 0)
            this.onChange();
        }
    }

    currentDateLength() {
        return this.currentDateEvent.reduce((sum, item) => sum + (!item.hidden ? 1 : 0), 0);
    }

    submitNoChanges() {
        if (!this.eventChangesSaved) {
            this.alertCtrl.create({
                header: this.translate.instant('__ALERT_UNSAVED_TITLE__'),
                message: this.translate.instant('__ALERT_UNSAVED_MESSAGE__'),
                buttons: [{
                    text: this.translate.instant('__ALERT_UNSAVED_BUTTON_LEAVE__'),
                    cssClass: 'alert-controller-warning',
                    handler: () => {
                        this.eventChangesSaved = true;
                        this.event.publish('form:saved', 'availability');
                    }
                }, this.translate.instant('__ALERT_UNSAVED_BUTTON_STAY__')]
            }).then(a => a.present());
        }
    }

    onSubmit() {
        let submitInfo: UpdateCoachAvailabilityModel = {
            startTime: new Date(this.selectedDate + 'T00:00:00').toISOString(),
            endTime: new Date(this.selectedDate + 'T23:59:59').toISOString(),
            availability: [],
            duration: 30
        };

        this.currentDateEvent.forEach((event) => {
            if (event.selected === true) {
                submitInfo.availability.push(new Date(event.startTime).toJSON());
            }
        })

        this.coachService.updateMyCoachAvailability(submitInfo)
            .then(r => {
                this.modalCount = 0;
                this.modalIsVisible = false;
                this.eventChangesSaved = true;
                this.event.publish('form:saved', 'availability');
                this.updateAvailabilityList();

                this.toast.create('success', '__TOAST_SELECTION_CONFIRMED__');
            });
    }

    timeArraySort(events) {
        events.sort(function (a, b) {
            if (a.startTime < b.startTime) {
                return -1;
            }
            if (a.startTime > b.startTime) {
                return 1;
            }
        })
        return events;
    }

    addMinToDate(date, minutes) {
        return new Date(date.getTime() + minutes * 60000)
    }

    addZero(n) {
        if (`${n}`.length === 1) {
            n = `0${n}`;
        }
        return n;
    }

    openAddYourTimeModal(){
        this.modalIsVisible2 = true;
    }

    closeAddYourTimeModal(){
        this.modalIsVisible2 = false;
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((i) => i.unsubscribe());
    }
}
